<style lang="stylus">
  #login-dp
    min-width 250px
    padding 14px 14px 0
    overflow hidden
    background-color rgba(255,255,255,.8)
    .help-block
      font-size 12px
    .bottom
      background-color rgba(255,255,255,.8)
      border-top 1px solid #ddd
      clear both
      padding 14px
    .social-buttons
      margin:12px 0
    .social-buttons a
      width: 49%;
    .form-group
      margin-bottom: 10px;
  .login-form
    padding 10px
  .login-success
    color green
  .login-error
    color red
</style>

<template lang="jade">
  form.login-form(role="form")
    div.login-success(v-if="successmessage")
      p {{ successmessage }}
    div.login-error(v-if="errormessage")
      p {{ errormessage }}
    div.form-group
       label.sr-only Email address
       input.form-control(
         placeholder="Member Number"
         v-model="username"
         v-on:submit.prevent="login"
         required
       )
    div.form-group
       label.sr-only Password
       input.form-control(
         type="password"
         placeholder="Password"
         v-model="password"
         required
       )
    div.form-group
       label.sr-only Password
       input.form-control(
         type="text"
         placeholder="Site ID"
         v-model="siteId"
         required
       )   
    div.form-group
      button.btn.btn-primary.btn-block(
        v-if="!proccessing"
        @click.prevent="login"
      ) {{ buttonText }}
      div.sk-cube-grid(v-else)
        - for (var x = 0; x < 9; x++)
            div.sk-cube.sk-cube-piece
</template>

<script>
  import { api } from 'src/vuex/getters'

  export default {
    data () {
      return {
        proccessing: false,
        errormessage: '',
        successmessage: '',
        password: '',
        username: '',
        siteId: '',
        buttonText: this.trans('login.buttonText')
      }
    },
    vuex: {
      getters: {
        api
      }
    },
    methods: {
      login () {
        this.proccessing = true
        this.$http.post(this.api.http.root + this.api.endpoints.login, {
          'username': this.username,
          'password': this.password,
          'siteId': this.siteId
        })
        .then(response => {
          if (response.data.success === true) {
            this.successmessage = this.trans('login.success')
          } else {
            this.errormessage = this.trans('login.failed', response.data.failureMessage)
          }
          this.proccessing = false
        }, response => {
          this.errormessage = this.trans('login.error')
          this.proccessing = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?0a024f2b